const TIPS = [
  "Right click the node canvas to add nodes",
  "Right click a node to clone or delete it",
  "Zoom, pan and rotate the 3D image with the mouse wheel and buttons",
  "Zoom and pan the node editor the same way",
  "If performance drops, lower the point count and raise delta to cover the same range",
  "Custom functions take 't' as their parameter and accept any math.js expression",
  "This is a technical demo — it may contain catastrophic bugs",
];

const LIBRARIES = [
  "React",
  "TypeScript",
  "React Flow (@xyflow/react)",
  "three.js",
  "Tailwind CSS",
  "math.js",
  "Firestore",
  "Vite",
];

export function Help({ onClose }: { onClose: () => void }) {
  return (
    <div
      role="presentation"
      onClick={onClose}
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 p-6"
    >
      <div
        role="dialog"
        aria-label="Help"
        onClick={(event) => event.stopPropagation()}
        className="scrollbar-slim max-h-full w-[min(38rem,100%)] overflow-y-auto rounded-2xl bg-panel p-8 text-neutral-200 shadow-2xl"
      >
        <h1 className="text-2xl font-bold text-white">Spiro v0.2</h1>
        <p className="mt-1 text-sm text-neutral-400">
          A node-based editor for parametric 3D curves, by Juan Manuel Scasso.
        </p>

        <h2 className="mt-6 text-sm font-semibold tracking-wider text-teal-400 uppercase">
          Usage tips
        </h2>
        <ul className="mt-2 list-disc space-y-1 pl-5 text-sm">
          {TIPS.map((tip) => (
            <li key={tip}>{tip}</li>
          ))}
        </ul>

        <h2 className="mt-6 text-sm font-semibold tracking-wider text-teal-400 uppercase">
          Libraries
        </h2>
        <ul className="mt-2 flex flex-wrap gap-2">
          {LIBRARIES.map((library) => (
            <li
              key={library}
              className="rounded-full bg-panel-raised px-2.5 py-1 text-xs"
            >
              {library}
            </li>
          ))}
        </ul>

        <p className="mt-6 text-xs text-neutral-500">
          Click anywhere to close.
        </p>
      </div>
    </div>
  );
}
